const taskTypes = {
  getTaskAction(task) {
    switch (task.type) {
      case this.$enums.taskTypes.FEEDBACK_TO_ACKNOWLEDGE:
        return "Acknowledge Feedback";
      case this.$enums.taskTypes.SURVEY_TO_TAKE:
        return "Complete Surveys";
      case this.$enums.taskTypes.RESOURCE_TO_READ:
        return "View Resources";
      case this.$enums.taskTypes.PULSE_TO_ANSWER:
        return "Complete Tracking";
      case this.$enums.taskTypes.ANNUAL_REVIEW_AVAILABLE:
        return "Complete QA Review";
      case this.$enums.taskTypes.ANNUAL_REVIEW_SIGNOFF_READY:
        return "Complete Signoff";
      case this.$enums.taskTypes.CHECK_IN_STARTED_BUT_NOT_FINISHED:
        return "View Meeting";
      case this.$enums.taskTypes.REVIEWS_AVAILABLE:
        return "Complete Reviews";
      case this.$enums.taskTypes.ANNUAL_REVIEW_HR_SIGNOFF_NEEDED:
        return "Finalize Reviews";
    }
    return "";
  },
  getTaskTitle(task) {
    switch (task.type) {
      case this.$enums.taskTypes.FEEDBACK_TO_ACKNOWLEDGE:
        return "View Anonymous Feedback";
      case this.$enums.taskTypes.SURVEY_TO_TAKE:
        return "Complete Shared Surveys";
      case this.$enums.taskTypes.RESOURCE_TO_READ:
        return "View Shared Training";
      case this.$enums.taskTypes.PULSE_TO_ANSWER:
        return "Complete Culture Tracking";
      case this.$enums.taskTypes.ANNUAL_REVIEW_AVAILABLE:
        return "Complete QA Review";
      case this.$enums.taskTypes.ANNUAL_REVIEW_SIGNOFF_READY:
        return "Annual Review Sign Off";
      case this.$enums.taskTypes.CHECK_IN_STARTED_BUT_NOT_FINISHED:
        return "Unfinished Meeting";
      case this.$enums.taskTypes.REVIEWS_AVAILABLE:
        return "Complete 360 Reviews";
      case this.$enums.taskTypes.ANNUAL_REVIEW_HR_SIGNOFF_NEEDED:
        return "Annual Review's Ready For HR";
    }
    return "";
  },
  getTaskTime(task) {
    switch (task.type) {
      case this.$enums.taskTypes.REVIEWS_AVAILABLE:
      case this.$enums.taskTypes.ANNUAL_REVIEW_HR_SIGNOFF_NEEDED:
      case this.$enums.taskTypes.ANNUAL_REVIEW_SIGNOFF_READY:
      case this.$enums.taskTypes.FEEDBACK_TO_ACKNOWLEDGE:
        return task.count;
      case this.$enums.taskTypes.SURVEY_TO_TAKE:
      case this.$enums.taskTypes.PULSE_TO_ANSWER:
        return task.count * 5;
      case this.$enums.taskTypes.RESOURCE_TO_READ:
        return task.count * 7;
      case this.$enums.taskTypes.CHECK_IN_STARTED_BUT_NOT_FINISHED:
        return task.count * 2;
      case this.$enums.taskTypes.ANNUAL_REVIEW_AVAILABLE:
        return task.count * 60;
    }
    return 0;
  },
  getTaskSort(task) {
    switch (task.type) {
      case this.$enums.taskTypes.FEEDBACK_TO_ACKNOWLEDGE:
        return 50;
      case this.$enums.taskTypes.CHECK_IN_STARTED_BUT_NOT_FINISHED:
        return 75;
      case this.$enums.taskTypes.ANNUAL_REVIEW_AVAILABLE:
        return 100;
      case this.$enums.taskTypes.ANNUAL_REVIEW_SIGNOFF_READY:
        return 110;
      case this.$enums.taskTypes.REVIEWS_AVAILABLE:
        return 180;
      case this.$enums.taskTypes.PULSE_TO_ANSWER:
        return 185;
      case this.$enums.taskTypes.SURVEY_TO_TAKE:
        return 190;
      case this.$enums.taskTypes.RESOURCE_TO_READ:
        return 200;
      case this.$enums.taskTypes.ANNUAL_REVIEW_HR_SIGNOFF_NEEDED:
        return 300;
    }
    return "";
  }
};

export default { methods: taskTypes };
